"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcMeterConsumptions = class UcMeterConsumptions extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    meter;
    onMeter(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("meter");
    }
    items;
    async $$load_items() {
        return this.meter.consumptions
            ? this.meter.consumptions.data
            : this.$fn.fetch('list_meter_consumptions', { parameters: { meter_id: this.meter.id } });
    }
    ux;
    dataMembers = ['items', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                items: null,
                ux: null,
            },
        };
    }
    async act_8320016629450276_emit_9478_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_8320016629450276_close_9477_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_8320016629450276_showModal_9476_getActionArgs($event) {
        return {
            name: "MeterConsumption",
            props: {
                meter: this.meter,
            },
        };
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8497951412896552_emit_9482_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_8497951412896552_close_9481_getWhen($event) {
        return !!$event.data.modalResult.ok;
    }
    async act_8497951412896552_showModal_9480_getActionArgs($event) {
        return {
            name: "MeterConsumption",
            props: {
                oid: $event.scope.item.id,
                meter: this.meter,
            },
        };
    }
    async evh_8497951412896552_clickPreventStop(event, scope) {
        return await this.actions.evh_8497951412896552_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_8320016629450276_emit_9478 = new core_1.actions.EmitAction({
            actionArgs: this.act_8320016629450276_emit_9478_getActionArgs,
            displayName: "emitReload",
            events: [],
        });
        const evh_8320016629450276_close_9477 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_emit_9478,
            event: "close",
            when: this.evh_8320016629450276_close_9477_getWhen,
            displayName: "emitReload",
        });
        const act_8320016629450276_showModal_9476 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_9476_getActionArgs,
            events: [evh_8320016629450276_close_9477],
        });
        const evh_8320016629450276_clickPreventStop_9475 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_9476,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_9475],
        });
        const act_8497951412896552_emit_9482 = new core_1.actions.EmitAction({
            actionArgs: this.act_8497951412896552_emit_9482_getActionArgs,
            displayName: "emitReload",
            events: [],
        });
        const evh_8497951412896552_close_9481 = new core_1.actions.EventHandlerImpl({
            action: act_8497951412896552_emit_9482,
            event: "close",
            when: this.evh_8497951412896552_close_9481_getWhen,
            displayName: "emitReload",
        });
        const act_8497951412896552_showModal_9480 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8497951412896552_showModal_9480_getActionArgs,
            events: [evh_8497951412896552_close_9481],
        });
        const evh_8497951412896552_clickPreventStop_9479 = new core_1.actions.EventHandlerImpl({
            action: act_8497951412896552_showModal_9480,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8497951412896552_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8497951412896552_clickPreventStop_9479],
        });
        return {
            act_8320016629450276_emit_9478,
            evh_8320016629450276_close_9477,
            act_8320016629450276_showModal_9476,
            evh_8320016629450276_clickPreventStop_9475,
            evh_8320016629450276_clickPreventStop,
            act_8497951412896552_emit_9482,
            evh_8497951412896552_close_9481,
            act_8497951412896552_showModal_9480,
            evh_8497951412896552_clickPreventStop_9479,
            evh_8497951412896552_clickPreventStop,
            emitReload: act_8497951412896552_emit_9482,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcMeterConsumptions.prototype, "meter", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('meter'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcMeterConsumptions.prototype, "onMeter", null);
UcMeterConsumptions = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcMeterConsumptions);
exports.default = UcMeterConsumptions;
vue_property_decorator_1.Vue.component("UcMeterConsumptions", UcMeterConsumptions);
